<div *ngIf="!useBasicThumbnail"
     [attr.data-replacer-uc-id]="ucId"
     [attr.data-replacer-uc-service]="ucService"
     [id]="id"
     class="container content-replacer"
     data-cy="uc-replacer-container"
>
  <img [src]="'/assets/icons/svg/progress_white.svg'"
       alt="icon"
       class="progress-icon"
       title="icon"
  >
  <div class="content">
    <h2>{{ 'ucBlockedContent.consentNeeded' | cxTranslate }}</h2>
    <h4 [innerHTML]=" 'ucBlockedContent.acceptThirdParty' | cxTranslate: { ucService }"
        class="accept-third-party"
        data-cy="uc-block-service"
    ></h4>
    <ng-container *ngIf="buttonText$ | async as buttonText">
      <mb-link [linkData]="{uid: cmsLinkType.SPECIAL, text: 'ucBlockedContent.accept' | cxTranslate: {buttonText}}"
               [styleClass]="['btn', 'btn-lg', 'btn-primary']"
               (click)="acceptService()"
               dataCy="uc-accept-button"
      ></mb-link>
    </ng-container>
    <h4 class="more-info">
      {{ 'ucBlockedContent.moreInfo' | cxTranslate }}
      <mb-link [linkData]="{uid: cmsLinkType.SPECIAL, text: 'ucBlockedContent.privacySettings' | cxTranslate}"
               (click)="openUcService()"
               dataCy="uc-block-service-info"
      ></mb-link>
      .
    </h4>
  </div>
</div>

<div *ngIf="useBasicThumbnail"
     [attr.data-replacer-uc-id]="ucId"
     [attr.data-replacer-uc-service]="ucService"
     [id]="id"
     class="container content-replacer content-replacer-basic-thumbnail"
     data-cy="uc-replacer-container"
>
  <img [src]="'/assets/images/video_thumbnail.jpg'"
       alt="icon"
       class="basic-thumbnail"
       title="icon"
  >
</div>
